import { render, staticRenderFns } from "./ActionRecommendReject.vue?vue&type=template&id=535e39c8&"
import script from "./ActionRecommendReject.vue?vue&type=script&lang=js&"
export * from "./ActionRecommendReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports